import React from 'react';
import createClass from 'create-react-class';
import { withTranslation } from 'react-i18next';

import ResultsStore from '../../../stores/ResultsStore';
import SearchStore from '../../../stores/SearchStore';
import ProfileStore from '../../../stores/ProfileStore';
import InternalsComponent from './InternalsComponent.react';
import HotelList from './HotelList.react';
import ResultsActions from '../../../actions/ResultsActions';
import SearchActions from '../../../actions/SearchActions';
import TitleManager from '../../../utils/TitleManager';
import RouterWrapper from '../../../utils/RouterWrapper';
import HotelStore from '../../../stores/HotelStore';

import Analytics from 'arbitrip-common/client/analytics';
import ResultsConstants from '../../../constants/ResultsConstants';
import { RESULTS_LOADING_LIMIT_IN_SECONDS } from 'arbitrip-common/general/constants/search-constants';
import { withRouter } from '../../../utils/withRouter';
import DocumentTitle from '../../general/DocumentTitle.react';

function getResultsState() {
	return {
		search_results: ResultsStore.getSearchResults(),
		results_status: ResultsStore.getResultsStatus(),
		search_destination: SearchStore.getDestinationAddress(),
		search_token: SearchStore.getToken(),

		has_unfiltered_results: ResultsStore.didReturnResults(),
		completed_search: ResultsStore.getSearchResultsCompletedSearch(),
		completed_hotels: ResultsStore.getSearchResultsCompletedHotels(),
		completed_listening: ResultsStore.getSearchResultsCompletedListening(),
		completed_delay: ResultsStore.getSearchResultsCompletedDelay(),
		breakfast_only: ResultsStore.isBreakfastOnly(),

		amenities_data: ResultsStore.getAmenitiesState(),

		arbitrip_points_applied: ResultsStore.areArbitripPointsApplied(),

		private_travel: SearchStore.isPrivateTravel(),
		contract_client_company_id: SearchStore.getContractClientCompanyId(),
	};
}

let _should_scroll = false;
let _last_scroll_y = -1;
let _mounted = false; // antipattern

function scrollLoop(scroll_target) {
	if (_should_scroll) {
		window.scrollTo(0, scroll_target);

		setTimeout(function () {
			if (_mounted) {
				if (_last_scroll_y < window.scrollY && window.scrollY < scroll_target) {
					_last_scroll_y = window.scrollY;
					scrollLoop(scroll_target);
				} else {
					_should_scroll = false;
					_last_scroll_y = -1;
				}
			}
		}, 50);
	}
}
const ResultsComponent = createClass({
	displayName: 'ResultsComponent',

	getInitialState: function () {
		let resultsState = getResultsState();

		resultsState.profile = ProfileStore.getProfile();

		resultsState.resultsTimer = false;

		return resultsState;
	},

	shouldComponentUpdate: function (nextProps, nextState) {
		const p = this.props;
		const s = this.state;
		return (
			nextProps.showHotelLoading !== p.showHotelLoading ||
			nextProps.searchTerms !== p.searchTerms ||
			nextProps.searchSessionCreatedTimestamp !== p.searchSessionCreatedTimestamp ||
			nextState.results_status !== s.results_status ||
			nextState.has_unfiltered_results !== s.has_unfiltered_results ||
			nextState.completed_search !== s.completed_search ||
			nextState.completed_hotels !== s.completed_hotels ||
			nextState.completed_listening !== s.completed_listening ||
			nextState.completed_delay !== s.completed_delay ||
			nextState.breakfast_only !== s.breakfast_only ||
			nextState.arbitrip_points_applied !== s.arbitrip_points_applied ||
			nextState.private_travel !== s.private_travel ||
			nextState.contract_client_company_id !== s.contract_client_company_id ||
			nextState.search_token !== s.search_token ||
			nextState.profile !== s.profile ||
			nextState.resultsTimer !== s.resultsTimer ||
			nextState.search_destination !== s.search_destination ||
			nextState.amenities_data !== s.amenities_data ||
			!!(nextState.search_results?.hotels?.length) !== !!(s.search_results?.hotels?.length)
		);
	},

	_shouldUpdate: function (newState) {
		const s = this.state;
		return (
			newState.results_status !== s.results_status ||
			newState.has_unfiltered_results !== s.has_unfiltered_results ||
			newState.completed_search !== s.completed_search ||
			newState.completed_hotels !== s.completed_hotels ||
			newState.completed_listening !== s.completed_listening ||
			newState.completed_delay !== s.completed_delay ||
			newState.breakfast_only !== s.breakfast_only ||
			newState.arbitrip_points_applied !== s.arbitrip_points_applied ||
			newState.private_travel !== s.private_travel ||
			newState.contract_client_company_id !== s.contract_client_company_id ||
			newState.search_token !== s.search_token ||
			!!(newState.search_results?.hotels?.length) !== !!(s.search_results?.hotels?.length)
		);
	},

	_onChange: function () {
		const newState = getResultsState();
		if (this._shouldUpdate(newState)) {
			this.setState(newState);
		}
	},

	_onProfileChange: function () {
		this.setState({ profile: ProfileStore.getProfile() });
	},

	componentDidMount: function () {
		ResultsStore.addChangeListener(this._onChange);
		ProfileStore.addChangeListener(this._onProfileChange);

		_mounted = true; // antipattern!

		this.startResultsTimer();

		const results = ResultsStore.getSearchResults();
		const selected_hotel = HotelStore.getHotelData();
		if (results && Array.isArray(results.hotels) && selected_hotel && selected_hotel.id) {
			for (const hotel of results.hotels) {
				if (hotel.id === selected_hotel.id) {
					_should_scroll = true;
					const scroll_target = HotelStore.getHotelScroll();
					return scrollLoop(scroll_target);
				}
			}
		}

		window.scrollTo(0, 0);
	},

	componentWillUnmount: function () {
		_mounted = false; // antipattern!
		_should_scroll = false;
		_last_scroll_y = -1;
		ResultsStore.removeChangeListener(this._onChange);
		ProfileStore.removeChangeListener(this._onProfileChange);
		if (this.resultsTimer) {
			clearTimeout(this.resultsTimer);
		}
	},

	componentDidUpdate(prevProps, prevState) {
		const { search_results } = this.state;
		const { hotels } = search_results;

		if (this.props.searchSessionCreatedTimestamp !== prevProps.searchSessionCreatedTimestamp) {
			this.setState({ resultsTimer: false }, this.startResultsTimer);
		}

		if (prevState.completed_listening !== this.state.completed_listening) {
			if (this.state.completed_listening) {
				Analytics.actions.responses.resultsFetchingTime(
					Math.ceil(Date.now() - this.props.searchSessionCreatedTimestamp.getTime()),
				);

				if (!hotels?.length) {
					Analytics.actions.responses.searchWithoutResults(
						this.state.profile,
						SearchStore.getDestination(),
						this.props.searchTerms,
					);
				}

				const matched_hotel = (hotels ?? []).filter((h) => h.hotelMatch)[0];
				if (matched_hotel?.representative_deals && !Object.keys(matched_hotel.representative_deals).length) {
					Analytics.actions.responses.searchedHotelWithoutDeals(
						this.state.profile,
						SearchStore.getDestination(),
						this.props.searchTerms,
					);
				}
			}
		}
	},

	elementInfiniteLoad: function () {
		const { hotels } = this.state.search_results;
		const { t } = this.props;

		if (this.state.has_unfiltered_results || (hotels && hotels.length > 0)) {
			return (
				<div className="loading">
					<i title={t('Loading')} className="fa fa-spin fa-spinner fa-1x" />
				</div>
			);
		} else {
			return null;
		}
	},

	handleClearFilters: function () {
		const { profile } = this.state;

		ResultsActions.clearFiltersAndApply();
		setTimeout(function () {
			ResultsActions.clearFiltersAndApply();
		}, 10);

		Analytics.actions.interactions.clearedResultsFilters(profile);
	},

	searchAgain: function () {
		SearchActions.search();
	},

	backToSearch: function () {
		const { navigate } = this.props;
		SearchActions.clearSearchTerms();
		return RouterWrapper.goToSearchPage(navigate);
	},

	startResultsTimer() {
		const results_duration_in_millis = RESULTS_LOADING_LIMIT_IN_SECONDS * 1000;

		if (this.resultsTimer) {
			clearTimeout(this.resultsTimer);
		}

		this.resultsTimer = setTimeout(() => {
			this.setState({ resultsTimer: true });
		}, results_duration_in_millis);
	},
	render: function () {
		const { completed_search, completed_hotels, has_unfiltered_results, resultsTimer } = this.state;
		const { t } = this.props;
		const is_show_loader = this.props.showHotelLoading;
		const { hotels } = this.state.search_results;
		const title = TitleManager.buildTitleStartsWith(this.state.search_destination);
		const custom_error = ResultsStore.getCustomError();
		const noHotelsFound = resultsTimer && completed_search && hotels?.length === 0;
		const noHotels = !hotels || hotels.length === 0;

		const show_hotel_loaders =
			((!completed_search || !completed_hotels) && !has_unfiltered_results && !noHotelsFound) || is_show_loader;

		const customErrorNote = (
			<div className="results-notes">
				<span>
					{custom_error}.{' '}
					<a href="#!" onClick={this.backToSearch}>
						{t('Back')}
					</a>
				</span>
			</div>
		);

		// TODO: consider waiting until stopping to listen to firebase
		const NOTES_CONFIGS = [
			{
				condition: noHotels && has_unfiltered_results,
				render: (
					<div className="results-notes">
						<img className="no-results-image" src="../img/results_page/space-man.svg" />
						<span>
							{t('BummerNoResults')}
							<br />{' '}
							<a href="#!" onClick={this.handleClearFilters}>
								{t('ClearFilters')}
							</a>
						</span>
					</div>
				),
				override: customErrorNote,
			},
			{
				condition: noHotels && ResultsStore.isErrorReturned(),
				render: (
					<div className="results-notes">
						<span>
							{t('SomethingWentWrong')}{' '}
							<a href="#!" onClick={this.searchAgain}>
								{t('SearchAgain')}
							</a>
						</span>
					</div>
				),
				override: customErrorNote,
			},
			{
				condition: noHotels && completed_search && completed_hotels,
				render: (
					<div className="results-notes">
						<span>
							{t('BummerNoResults')} <a href="/search">{t('TryAgain')}</a>
						</span>
					</div>
				),
				override: customErrorNote,
			},
			{
				condition: noHotelsFound,
				render: (
					<div className="results-notes">
						<img className="no-results-image" src="../img/results_page/space-man.svg" />
						<span>{t('NoResultsForDestination')}</span>
					</div>
				),
			},
			{
				condition: !noHotels && this.state.results_status === ResultsConstants.STATUSES.WAITING,
				render: this.elementInfiniteLoad(),
			},
		];

		const matchedConfig = NOTES_CONFIGS.find(({ condition }) => condition);
		const NOTES = matchedConfig ? (custom_error && matchedConfig.override ? matchedConfig.override : matchedConfig.render) : null;

		// const POWERED_BY_TRUST_YOU = (hotels && hotels.length > 0)
		//   ? <div className="trust-you">
		//     <a href="//trustyou.com" className="verified-reviews" target="_blank" rel="noopener noreferrer">
		//       <img src="//api.trustyou.com/static/img/powered-by-trustyou-small.png" alt="Verified Reviews TrustYou" />
		//     </a>
		//   </div>
		//   : null;

		let results_classes = 'results';
		if (this.state.results_status === ResultsConstants.STATUSES.WAITING) {
			results_classes += ' loading';
		}

		return (
			<DocumentTitle title={title}>
				<React.Fragment>
					<InternalsComponent
						hotels={hotels}
						searchSessionCreatedTimestamp={this.props.searchSessionCreatedTimestamp}
					/>
					<div className={results_classes}>
						<HotelList
							showLoaders={show_hotel_loaders}
							profile={this.state.profile}
							searchToken={this.state.search_token}
							searchTerms={this.props.searchTerms}
							completed_hotels={this.state.completed_hotels}
							completed_search={this.state.completed_search}
							completed_listening={this.state.completed_listening}
							breakfast_only={this.state.breakfast_only}
							completed_delay={this.state.completed_delay}
							arbitrip_points_applied={this.state.arbitrip_points_applied}
							amenities_data={this.state.amenities_data}
							private_travel={this.state.private_travel}
							contract_client_company_id={this.state.contract_client_company_id}
						/>

						{NOTES}

						{/* {POWERED_BY_TRUST_YOU} */}
					</div>
				</React.Fragment>
			</DocumentTitle>
		);
	},
});

export default React.memo(withTranslation()(withRouter(ResultsComponent)));
